module.exports = __webpack_public_path__ + "img/pic_share.35745198.png";